const initialState = {
    doctypes: window.orderFormData.doctypes || {},
    doctypesQueue: window.orderFormData.doctypesQueue || [],
    wrlevelsByDoctypeId: window.orderFormData.wrlevelsByDoctypeId,
    doctypeIdsByWrlevelName: window.orderFormData.doctypeIdsByWrlevelName,
    wrlevelsDescriptionsByName: window.orderFormData.wrlevelsDescriptionsByName,
    urgencies: window.orderFormData.urgencies,
    coverLetters: [1,2,3,4,5,6,7,8,9,10],
    coverLetterDoctypeIds: [34, 50, 133, 137, 138, 335, 331],
    coverLetterPrice: 23,
    vases: window.orderFormData.vases || {},
    currencies: window.orderFormData.currencies,
    currencyRates: window.orderFormData.currencyRates,
    countries: window.orderFormData.countries,
    prices: window.orderFormData.prices,
};

let doctypesById = {}
initialState.doctypes.map(doctype => {
    doctypesById[doctype.id] = doctype
})
initialState.doctypesById = doctypesById

const domain = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state
    }
}

export default domain
